import http from "../../utils/httpClient";

class inventoryService {

  getStockReport = async (query) => {
    return await http.get("/api/PurchaseOrder/GetInventoryMaster", { params: query });
  };

  getInventoryDetails = async (query) => {
    return await http.get("/api/PurchaseOrder/GetInventoryDetails", { params: query });
  };
}
export default new inventoryService();
